(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acorn-product"]) return;
  try {
    
function initAcornGalleries(){document.querySelectorAll('[data-at-gallery]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';gallery.querySelectorAll('[data-at-thumb]').forEach(button=>{button.addEventListener('click',()=>{const image=gallery.querySelector('[data-at-main]');image.src=button.dataset.src;image.alt=button.dataset.alt;gallery.querySelector('[data-at-large]').href=button.dataset.large;gallery.querySelector('[data-at-caption]').textContent=button.dataset.alt;gallery.querySelectorAll('[data-at-thumb]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});});});}
initAcornGalleries();document.addEventListener('shopify:section:load',initAcornGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-product"]) return;
  try {
    
function initAcornGalleries(){document.querySelectorAll('[data-at-gallery]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';gallery.querySelectorAll('[data-at-thumb]').forEach(button=>{button.addEventListener('click',()=>{const image=gallery.querySelector('[data-at-main]');image.src=button.dataset.src;image.alt=button.dataset.alt;gallery.querySelector('[data-at-large]').href=button.dataset.large;gallery.querySelector('[data-at-caption]').textContent=button.dataset.alt;gallery.querySelectorAll('[data-at-thumb]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});});});}
initAcornGalleries();document.addEventListener('shopify:section:load',initAcornGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-library"]) return;
  try {
    
function initAcornGalleries(){document.querySelectorAll('[data-at-gallery]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';gallery.querySelectorAll('[data-at-thumb]').forEach(button=>{button.addEventListener('click',()=>{const image=gallery.querySelector('[data-at-main]');image.src=button.dataset.src;image.alt=button.dataset.alt;gallery.querySelector('[data-at-large]').href=button.dataset.large;gallery.querySelector('[data-at-caption]').textContent=button.dataset.alt;gallery.querySelectorAll('[data-at-thumb]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});});});}
initAcornGalleries();document.addEventListener('shopify:section:load',initAcornGalleries);

  } catch(e) { console.error(e); }
})();
})();
